import { render, staticRenderFns } from "./WarningList.vue?vue&type=template&id=0a6ad950&scoped=true&"
import script from "./WarningList.vue?vue&type=script&lang=js&"
export * from "./WarningList.vue?vue&type=script&lang=js&"
import style0 from "./WarningList.vue?vue&type=style&index=0&id=0a6ad950&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a6ad950",
  null
  
)

export default component.exports